export const LegendImage = () => {
  return (
    <svg className="h-8 w-full" viewBox="0 0 657 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4935_21909)">
        <rect width="33" height="33" fill="url(#paint0_linear_4935_21909)" />
        <text
          transform="translate(41.1133 10.8066) rotate(0.6)"
          fill="#1E1E1C"
          xmlSpace="preserve"
          style={{whiteSpace: 'pre'}}
          fontFamily="ARS Maquette Pro"
          fontSize="17"
          fontWeight="500"
          letterSpacing="0em"
        >
          <tspan x="0" y="11.322">
            Lara
          </tspan>
        </text>
        <rect x="119" width="33" height="33" fill="url(#paint1_linear_4935_21909)" />
        <text
          transform="translate(160.113 10.2773) rotate(0.6)"
          fill="#1E1E1C"
          xmlSpace="preserve"
          style={{whiteSpace: 'pre'}}
          fontFamily="ARS Maquette Pro"
          fontSize="17"
          fontWeight="500"
          letterSpacing="0em"
        >
          <tspan x="0" y="11.322">
            OpenAI&#x2019;s GPT-4o
          </tspan>
        </text>
        <rect x="339" width="33" height="33" fill="url(#paint2_linear_4935_21909)" />
        <text
          transform="translate(380.113 10.2676) rotate(0.6)"
          fill="#1E1E1C"
          xmlSpace="preserve"
          style={{whiteSpace: 'pre'}}
          fontFamily="ARS Maquette Pro"
          fontSize="17"
          fontWeight="500"
          letterSpacing="0em"
        >
          <tspan x="0" y="11.322">
            Google Translate
          </tspan>
        </text>
        <rect x="561" width="33" height="33" fill="url(#paint3_linear_4935_21909)" />
        <text
          transform="translate(602.113 10.7168) rotate(0.6)"
          fill="#1E1E1C"
          xmlSpace="preserve"
          style={{whiteSpace: 'pre'}}
          fontFamily="ARS Maquette Pro"
          fontSize="17"
          fontWeight="500"
          letterSpacing="0em"
        >
          <tspan x="0" y="11.322">
            DeepL
          </tspan>
        </text>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4935_21909"
          x1="16.5"
          y1="0"
          x2="16.5"
          y2="33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AC69A9" />
          <stop offset="1" stopColor="#6F5BA4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4935_21909"
          x1="135.5"
          y1="0"
          x2="135.5"
          y2="33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EC6917" />
          <stop offset="0.18" stopColor="#E66417" />
          <stop offset="0.4" stopColor="#D65619" />
          <stop offset="0.65" stopColor="#BC3E1C" />
          <stop offset="0.92" stopColor="#981E20" />
          <stop offset="1" stopColor="#8C1422" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4935_21909"
          x1="355.5"
          y1="0"
          x2="355.5"
          y2="33"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.13" stopColor="#C8D400" />
          <stop offset="0.22" stopColor="#C2D202" />
          <stop offset="0.33" stopColor="#B1CD0B" />
          <stop offset="0.45" stopColor="#95C518" />
          <stop offset="0.59" stopColor="#6FBA2C" />
          <stop offset="0.73" stopColor="#3EAD44" />
          <stop offset="0.75" stopColor="#37AB48" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4935_21909"
          x1="577.505"
          y1="0.01"
          x2="577.505"
          y2="33.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2EA6CF" />
          <stop offset="0.19" stopColor="#2CA2C9" />
          <stop offset="0.44" stopColor="#2997B8" />
          <stop offset="0.73" stopColor="#24869C" />
          <stop offset="1" stopColor="#1E727C" />
        </linearGradient>
        <clipPath id="clip0_4935_21909">
          <rect width="656.112" height="33" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
